import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";

import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";
import "rxjs/add/operator/catch";

import * as globalConst from "./../../../../constants";
import { of } from "rxjs/observable/of";

@Injectable()
export class CockpitService {
  private apiUrl = globalConst.baseAPI; // URL para web api

  constructor(private http: Http) {}

  getUserOrdersRequisition(orderby, sort) {
    return this.http
      .get(
        this.apiUrl +
          "cookpit/v1/getshippingdivisioncockpit?$orderby=" +
          orderby +
          " " +
          sort +
          "",
        JSON.parse(localStorage.getItem("yara.connectionHeader"))
      )
      .map((res: Response) => res.json())
      .catch((e) => {
        if (e.status === 401) {
          return Observable.throw("Unauthorized");
        }
      });
  }

  getUserOrdersResponsable(orderby, sort, defaultOrder) {
    if (defaultOrder) {
      // Gambiarra!!!
      orderby += " " + sort;
      sort = ",LeadTime desc";
    }

    return this.http
      .get(
        this.apiUrl +
          "cookpit/v1/getproposal?$orderby=" +
          orderby +
          " " +
          sort +
          "",
        JSON.parse(localStorage.getItem("yara.connectionHeader"))
      )
      .map((res: Response) => res.json())
      .catch((e) => {
        if (e.status === 401) {
          return Observable.throw("Unauthorized");
        }
      });
  }

  getUserOrdersFollow(orderby, sort, defaultOrder) {
    if (defaultOrder) {
      // Gambiarra!!!
      orderby += " " + sort;
      sort = ",LeadTime desc";
    }

    return this.http
      .get(
        this.apiUrl +
          "cookpit/v1/getproposalfollow?$orderby=" +
          orderby +
          " " +
          sort +
          "",
        JSON.parse(localStorage.getItem("yara.connectionHeader"))
      )
      .map((res: Response) => res.json())
      .catch((e) => {
        if (e.status === 401) {
          return Observable.throw("Unauthorized");
        }
      });
  }

  getExtensionProposal(follow, orderby, sort) {
    return this.http
      .get(
        this.apiUrl +
          "cookpit/v1/getprolongation/" +
          follow +
          "?$orderby=" +
          orderby +
          " " +
          sort +
          "",
        JSON.parse(localStorage.getItem("yara.connectionHeader"))
      )
      .map((res: Response) => res.json())
      .catch((e) => {
        if (e.status === 401) {
          return Observable.throw("Unauthorized");
        }
      });
  }

  getExtraProposal(follow, orderby, sort) {
    return this.http
      .get(
        this.apiUrl +
          "cookpit/v1/getextraproposal/" +
          follow +
          "?$orderby=" +
          orderby +
          " " +
          sort +
          "",
        JSON.parse(localStorage.getItem("yara.connectionHeader"))
      )
      .map((res: Response) => res.json())
      .catch((e) => {
        if (e.status === 401) {
          return Observable.throw("Unauthorized");
        }
      });
  }

  getSalesOrderFollow(orderby, sort) {
    return this.http
      .get(
        this.apiUrl +
          "cookpit/v1/getsalesorderfollow?$orderby=" +
          orderby +
          " " +
          sort +
          "",
        JSON.parse(localStorage.getItem("yara.connectionHeader"))
      )
      .map((res: Response) => res.json())
      .catch((e) => {
        if (e.status === 401) {
          return Observable.throw("Unauthorized");
        }
      });
  }

  getUserAllowanceProposal(follow, orderby, sort) {
    return this.http
      .get(
        this.apiUrl +
          "cookpit/v1/getallowance/" +
          follow +
          "?$orderby=" +
          orderby +
          " " +
          sort +
          "",
        JSON.parse(localStorage.getItem("yara.connectionHeader"))
      )
      .map((res: Response) => res.json())
      .catch((e) => {
        if (e.status === 401) {
          return Observable.throw("Unauthorized");
        }
      });
  }

  getEconomicGroups(orderby, sort) {
    return this.http
      .get(
        this.apiUrl +
          "cookpit/v1/geteconomicgroup?$orderby=" +
          orderby +
          " " +
          sort +
          "",
        JSON.parse(localStorage.getItem("yara.connectionHeader"))
      )
      .map((res: Response) => res.json())
      .catch((e) => {
        if (e.status === 401) {
          return Observable.throw("Unauthorized");
        }
      });
  }

  getAlcadasComerciais(follow, orderby, sort) {
    return this.http
      .get(
        this.apiUrl +
          "cookpit/v1/gettradearea/" +
          follow +
          "?$orderby=" +
          orderby +
          " " +
          sort +
          "",
        JSON.parse(localStorage.getItem("yara.connectionHeader"))
      )
      .map((res: Response) => res.json())
      .catch((e) => {
        if (e.status === 401) {
          return Observable.throw("Unauthorized");
        }
      });
  }

  getBulkRewal(follow, orderby, sort) {
    return this.http
      .get(
        this.apiUrl +
          "cookpit/v1/getrenewalproposal?$orderby=" +
          orderby +
          " " +
          sort +
          "",
        JSON.parse(localStorage.getItem("yara.connectionHeader"))
      )
      .map((res: Response) => res.json())
      .catch((e) => {
        if (e.status === 401) {
          return Observable.throw("Unauthorized");
        }
      });
  }

  getAnalysisSummary(gcs: string[]) {
    return this.http
    	.post(this.apiUrl + "resumoanaliseaprovacao/v1/getresumoanalise", gcs, JSON.parse(localStorage.getItem('yara.connectionHeader')))
    	.map((res: Response) => res.json())
    	.catch(e => {
    		if (e.status === 401) {
    			return Observable.throw('Unauthorized');
    		}
    	});
  }

  getApprovalSummary(gcs: string[]) {
    return this.http
    	.post(this.apiUrl + "resumoanaliseaprovacao/v1/getresumoaprovacao", gcs, JSON.parse(localStorage.getItem('yara.connectionHeader')))
    	.map((res: Response) => res.json())
    	.catch(e => {
    		if (e.status === 401) {
    			return Observable.throw('Unauthorized');
        }
    	});
    }
}



// WEBPACK FOOTER //
// ./src/app/cockpit/service/cockpit/cockpit.service.ts